import { render, staticRenderFns } from "./developers.vue?vue&type=template&id=5e8ec95c"
import script from "./developers.vue?vue&type=script&lang=js"
export * from "./developers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports